export class User {
    userName: string;
    token: string;
    role: string;
    isAuthenticated: boolean;
    passWord: string;
    currentState: string;
}
